



















































































































































































































































import { Component, Vue, Provide, Prop } from "vue-property-decorator";
import { Image } from "vant";
import { IInfoThemeDetails } from "@/api/wanzhou/types";
import Label from "./Label.vue";
@Component({
  components: {
    Label,
    vanImage: Image
  }
})
export default class NewsItem extends Vue {
  @Prop()
  private newsItem!: any;

  private startPoint!: any;
  private appId: string = "";
  // computed
  get infoLabels() {
    let result = [];
    result =
      typeof this.newsItem.infoLabel == "string" &&
      this.newsItem.infoLabel.split(",").filter((v: string) => !!v);
    return result;
  }

  created() {
    this.appId = (this.$route.query.appId as string) || "28";
  }

  /** 以下两个方法可以理解为点击新闻，触发点击事件，做了防误触的处理 */
  touchstart(e: any, item: any) {
    this.startPoint = {
      x: e.changedTouches[0].pageX,
      y: e.changedTouches[0].pageY
    };
  }
  touchend(e: any, item: any) {
    let nowPoint = {
      x: e.changedTouches[0].pageX,
      y: e.changedTouches[0].pageY
    };
    if (
      Math.abs(nowPoint.x - this.startPoint.x) < 5 &&
      Math.abs(nowPoint.y - this.startPoint.y) < 5
    ) {
      //相当于新闻点击事件
      this.$emit("newItemClick", item);
    }
  }
  //上万数字
  praiseNum(num: number) {
    if (num >= 10000) {
      return (num / 10000).toFixed(2) + "w";
    } else {
      return num;
    }
  }
  // 切割标签
  getinfoLabel(str: string) {
    return str.split(",")[1];
  }
}
